import { azureTokenInfo } from "./azureTokenInfo";
import { envConfig } from "../config/envConfigs";
import { environment } from "../../src/constants/environment";
import { getBrowserName } from "./browserName";
import { getDeviceType } from "./deviceType";

export const getLoggerEventPayload = () => {
  return {
    applicationName: "Retail",
    browserName: getBrowserName(),
    cssApplicationName: "FESDK",
    deviceType: getDeviceType(),
    environment,
    existingUser: sessionStorage.getItem("ev_existingUser") ? sessionStorage.getItem("ev_existingUser") : "false",
    exit: sessionStorage.getItem("ev_exit"),
    isAccessTokenReceived: sessionStorage.getItem("ev_accessTokenReceived")
      ? sessionStorage.getItem("ev_accessTokenReceived")
      : "false",
    itgName: sessionStorage.getItem("ev_itgName"),
    locationId: sessionStorage.getItem("ev_locationId"),
    pageName: sessionStorage.getItem("ev_pageName"),
    processName: "R360_Anticipated_Visits_Redesign",
    sessionId: sessionStorage.getItem("ev_sessionId"),
    status: sessionStorage.getItem("ev_status"),
    statusCode: sessionStorage.getItem("ev_statusCode"),
    stepId: sessionStorage.getItem("ev_stepId"),
    submitButton: sessionStorage.getItem("ev_submitButton"),
    userAgent: navigator.userAgent,
  };
};

export const postLoggerEventDetails = async (eventName: string, logType: string) => {
  const reqPayload = {
    feProcessId: envConfig?.appConfig?.exitEventFlowId,
    ...envConfig?.appConfig?.appDetails,
    ConsumerId: "Retail360",
    LogType: logType,
    TransactionId: sessionStorage.getItem("ev_sessionId")
      ? `${sessionStorage.getItem("ev_sessionId")}_${Math.random().toString(36).substr(2, 15)}`
      : Math.random().toString(36).substr(2, 15),
    eventName,
    kv: getLoggerEventPayload(),
    timestamp: new Date().toISOString(),
  };

  const xhttp = new XMLHttpRequest();
  xhttp.open("POST", `${envConfig.urls.exitEvent}`, true);
  xhttp.setRequestHeader("Authorization", `Bearer ${(await azureTokenInfo).access_token}`);
  xhttp.setRequestHeader("Content-type", "application/json");
  xhttp.setRequestHeader("AuthType", "AzureAD");
  xhttp.timeout = 5000;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  xhttp.onreadystatechange = function () {};
  xhttp.send(JSON.stringify(reqPayload));
};
